import { useSelector } from 'react-redux'
import { ComposeChart } from '../../common/composeChart'
import { handleDataChart } from '../../helper'
import { selectActiveRowGroupId, selectData, selectYears } from './store/slice'

export const Chart = () => {
  const data = useSelector(selectData)
  const activeRowGroupId = useSelector(selectActiveRowGroupId)
  const years = useSelector(selectYears)

  const chartData = handleDataChart(data, activeRowGroupId, years)

  return <ComposeChart chartData={chartData} />
}
